<template>
  <v-img v-bind="$attrs" :src="imgUrl" v-on="$listeners" />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'CfsIcon',
  props: {
    iconName: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const getImageUrl = (path: string): string => {
      return `${new URL(`/src/assets/img/icons/${path}.svg`, import.meta.url)}`;
    };
    const imgUrl = computed(() => {
      if (props.iconName?.endsWith('.svg') || props.iconName?.startsWith('data:image')) {
        return props.iconName;
      }
      return getImageUrl(props.iconName);
    });
    return { getImageUrl, imgUrl };
  },
});
</script>
